export type News = {
  beats: string[];
  postId: string;
  publishDate: string;
  headline: string;
  summary: string;
  images: Image[];
  derivedImages: DerivedImages;
  showReadMore: boolean;
  outlet: Outlet;
  source: null;
  panel: null;
  type: NewsType;
  videoSource: VideoSource | null;
};

export type DerivedImages = {
  images: Images;
  predominantColor: PredominantColor;
};

export type Images = {
  bingePortraitImage: string;
  largePortraitImage?: string;
  largeLandscapeImage?: string;
  smallLandscapeImage?: string;
  extraSmallPortraitImage?: string;
  newsVideoImage?: string;
};

export type PredominantColor = {
  type: string;
  color: string;
};

export type Image = {
  tagName: TagName;
  supportedImages: SupportedImages;
};

export type SupportedImages = {
  original: string;
  rounded?: string;
};

export type Outlet = {
  id: string;
  outletName: string;
  logo: string;
  website: string;
};

export enum NewsType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type VideoSource = {
  url: string;
  format: Format;
};

export enum Format {
  Fullscreen = 'FULLSCREEN',
  Widescreen = 'WIDESCREEN'
}

export enum TagName {
  SwishNewsArticleMainImage = 'swishNewsArticleMainImage',
  SwishNewsArticleTileImage = 'swishNewsArticleTileImage',
  SwishNewsCardLandscapeImage = 'swishNewsCardLandscapeImage',
  SwishNewsCardPortraitImage = 'swishNewsCardPortraitImage'
}

export type SwishNewsTopStoriesCollection = {
  items: SwishNewsTopStoriesCollectionItem[];
};

export type SwishNewsTopStoriesCollectionItem = {
  newsCollection: NewsCollection;
};

export type NewsCollection = {
  items: NewsCDS[];
  total: number;
};

export type SwishNewsContentfulCollection = {
  total: number;
  nextPageExists: boolean;
  items: NewsCDS[];
  unifiedNews: null;
};

export type RelatedSwishNewsContentfulCollection = {
  total: number;
  items: NewsCDS[];
};

export type NewsCDS = {
  locationType: LocationType;
  sortType: SortType;
  sys: Sys;
  headline: string;
  summary: string;
  publishedDate: string;
  images: Image[];
  categories: string[];
  outlet: OutletCDS;
  type: NewsType;
  weightage: number;
  storyVideo: StoryVideo[] | null;
  derivedImages: DerivedImages;
  cityLocationTags: string[] | null;
  stateLocationTags: string[] | null;
  countryLocationTags: string[] | null;
  isAutoPublished: boolean;
  sourceUrl: string;
};

export enum LocationType {
  Others = 'others'
}

export enum SortType {
  Recency = 'recency'
}

export type StoryVideo = {
  url: string;
  type: string;
};

export type Sys = {
  id: string;
  firstPublishedAt: string;
};

export type OutletCDS = {
  outletName: string;
  website: string;
  logo: Logo;
};

export type Logo = {
  url: string;
};

export type NewsDetailsCDS = {
  sys: Sys;
  headline: string;
  summary: string;
  fullContent: string;
  contentSegmentList: string[];
  sourceUrl: string;
  showReadMore: boolean;
  outlet: OutletCDS;
  images: Image[];
  categories: string[];
  publishedDate: string;
  tags: string[] | null;
};

// List of news categories
export enum NewsCategory {
  TopNews = 'Top News',
  BreakingNews = 'Breaking News',
  Entertainment = 'Entertainment',
  Video = 'Videos'
}
